import { create } from 'zustand';

import { EMPTY_NODES } from '../consts';
import { type ChatHistoryNodeSlice, createChatHistoryNodeSlice } from './slices/createChatHistoryNodeSlice';

export type ChatHistoryNodeState = ChatHistoryNodeSlice;

export const useChatHistoryNodeStore = create<ChatHistoryNodeState>()((...args) => ({
  ...createChatHistoryNodeSlice()(...args),
}));

/** Returns all chat history nodes for the current thread. */
export const useChatHistoryNodes = () => {
  return useChatHistoryNodeStore((state) => (Object.keys(state.nodes).length > 0 ? state.nodes : EMPTY_NODES));
};
